/**
 * 전체 화면 로딩 스피너 (Precision Arc)
 * 페이지 전환 시 사용하는 공통 로딩 컴포넌트
 */

export function FullScreenSpinner({ text = "로딩 중..." }: { text?: string }) {
  return (
    <div className="flex h-screen items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="spinner-arc-track">
          <div className="spinner-arc-dot" />
        </div>
        <p className="text-sm text-slate-400">{text}</p>
      </div>
    </div>
  );
}
